import { IAction } from "store/store.interface";
import {
  AUTH_LOGIN,
  AUTH_SET_COUNTRY,
  AUTH_UPDATE_LOCATION,
  AUTH_LOGOUT,
} from "../store.types";
import Cookie from "universal-cookie";

const cookie = new Cookie();

export enum ERoles {
  CREATOR = "creator",
  MANAGER = "manager",
  READONLY = 'readonly',
  ADMIN = 'admin'
}
export enum EStores {
  mafuae = "mafuae",
  mafkwt = "mafkwt",
  mafbhr = "mafbhr",
  mafqat = "mafqat",
  mafegy = "mafegy",
  maflbn = "maflbn",
  mafjor = "mafjor",
  mafsau = "mafsau",
  mafpak = "mafpak",
  mafomn = "mafomn",
  mafken = "mafken",
  mafirn = "mafirn",
  mafirq = "mafirq",
  mafgeo = "mafgeo",
  mafuzb = "mafuzb",
  mafinstorejor = "mafinstore-jor",
  mafinstoreuae = "mafinstore-uae",
  mafinstorelbn = "mafinstore-lbn",
  mafinstorepak = "mafinstore-pak",
  mafinstorekwt = "mafinstore-kwt",
  mafinstorebhr = "mafinstore-bhr",
  mafinstoreomn = "mafinstore-omn",
  mafinstoreegy = "mafinstore-egy",
}

export enum ETokenTypes {
  BEARER = "Bearer",
}

export interface IPermission {
  type: "campaign";
  value: string;
}

export interface ILoginState {
  email: string;
  name: string;
  roles: ERoles[];
  storeIds: EStores[];
  permissions: {
    [storeId: string]: IPermission[];
  };
}

export interface IAuthState extends Partial<ILoginState> {
  location?: string;
  storeId?: EStores;
  timeZone: string;
}

const storeId = cookie.get("pe_storeid");
const timeZone = cookie.get("pe_tz") || "Asia/Dubai";

export const INITIAL_STATE = {
  storeId,
  timeZone,
};

export default (state: IAuthState = INITIAL_STATE, action: IAction) => {
  switch (action.type) {
    case AUTH_LOGIN:
      return {
        ...state,
        ...action.payload,
      };
    case AUTH_SET_COUNTRY:
      return {
        ...state,
        ...action.payload,
      };
    case AUTH_UPDATE_LOCATION:
      return {
        ...state,
        location: action.payload,
      };
    case AUTH_LOGOUT:
      return { isAuthenticated: false };
    default:
      return state;
  }
};
